import axios from 'axios'
import store from '@/store'

const API_BASE = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app/academy'

function getHeaders () {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Token ${store.getters.getToken}`
  }
}

export const academyAPI = {
  // TEACHERS
  async getTeachers (params = {}) {
    try {
      const response = await axios.get(`${API_BASE}/teachers/`, {
        headers: getHeaders(),
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching teachers:', error)
      throw error
    }
  },

  async getTeacher (teacherId) {
    try {
      const response = await axios.get(`${API_BASE}/teachers/${teacherId}/`, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching teacher:', error)
      throw error
    }
  },

  async createTeacher (teacherData) {
    try {
      const response = await axios.post(`${API_BASE}/teachers/`, teacherData, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error creating teacher:', error)
      throw error
    }
  },

  async updateTeacher (teacherId, teacherData) {
    try {
      const response = await axios.patch(`${API_BASE}/teachers/${teacherId}/`, teacherData, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error updating teacher:', error)
      throw error
    }
  },

  async deleteTeacher (teacherId) {
    try {
      await axios.delete(`${API_BASE}/teachers/${teacherId}/`, {
        headers: getHeaders()
      })
      return true
    } catch (error) {
      console.error('Error deleting teacher:', error)
      throw error
    }
  },

  // CLINICS
  async getClinics (params = {}) {
    try {
      const response = await axios.get(`${API_BASE}/clinics/`, {
        headers: getHeaders(),
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching clinics:', error)
      throw error
    }
  },

  async getClinic (clinicId) {
    try {
      const response = await axios.get(`${API_BASE}/clinics/${clinicId}/`, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching clinic:', error)
      throw error
    }
  },

  async createClinic (clinicData) {
    try {
      const response = await axios.post(`${API_BASE}/clinics/`, clinicData, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error creating clinic:', error)
      throw error
    }
  },

  async updateClinic (clinicId, clinicData) {
    try {
      const response = await axios.patch(`${API_BASE}/clinics/${clinicId}/`, clinicData, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error updating clinic:', error)
      throw error
    }
  },

  async deleteClinic (clinicId) {
    try {
      await axios.delete(`${API_BASE}/clinics/${clinicId}/`, {
        headers: getHeaders()
      })
      return true
    } catch (error) {
      console.error('Error deleting clinic:', error)
      throw error
    }
  },

  // STUDENTS
  async getStudents (params = {}) {
    try {
      const response = await axios.get(`${API_BASE}/students/`, {
        headers: getHeaders(),
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching students:', error)
      throw error
    }
  },

  async getStudent (studentId) {
    try {
      const response = await axios.get(`${API_BASE}/students/${studentId}/`, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching student:', error)
      throw error
    }
  },

  async createStudent (studentData) {
    try {
      const response = await axios.post(`${API_BASE}/students/`, studentData, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error creating student:', error)
      throw error
    }
  },

  async updateStudent (studentId, studentData) {
    try {
      const response = await axios.patch(`${API_BASE}/students/${studentId}/`, studentData, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error updating student:', error)
      throw error
    }
  },

  // ENROLLMENTS
  async createEnrollment (enrollmentData) {
    try {
      const response = await axios.post(`${API_BASE}/enrollments/`, enrollmentData, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error creating enrollment:', error)
      throw error
    }
  },

  async updateEnrollment (enrollmentId, enrollmentData) {
    try {
      const response = await axios.patch(`${API_BASE}/enrollments/${enrollmentId}/`, enrollmentData, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error updating enrollment:', error)
      throw error
    }
  },

  async deleteEnrollment (enrollmentId) {
    try {
      await axios.delete(`${API_BASE}/enrollments/${enrollmentId}/`, {
        headers: getHeaders()
      })
      return true
    } catch (error) {
      console.error('Error deleting enrollment:', error)
      throw error
    }
  },

  // STATS
  async getStats () {
    try {
      const response = await axios.get(`${API_BASE}/stats/`, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching stats:', error)
      throw error
    }
  }
}

// Utilidades
export const academyUtils = {
  getClinicTypeColor (type) {
    const colors = {
      swing: 'blue',
      putting: 'green',
      pitch: 'orange',
      full_swing: 'purple',
      short_game: 'red'
    }
    return colors[type] || 'grey'
  },

  getClinicTypeLabel (type) {
    const labels = {
      swing: 'Swing',
      putting: 'Putting',
      pitch: 'Pitch',
      full_swing: 'Swing Completo',
      short_game: 'Juego Corto'
    }
    return labels[type] || 'Otro'
  },

  getLevelColor (level) {
    const colors = {
      basico: 'green',
      intermedio: 'orange',
      avanzado: 'red'
    }
    return colors[level] || 'grey'
  },

  getLevelLabel (level) {
    const labels = {
      basico: 'Básico',
      intermedio: 'Intermedio',
      avanzado: 'Avanzado'
    }
    return labels[level] || 'Otro'
  },

  getEnrollmentStatusColor (status) {
    const colors = {
      enrolled: 'blue',
      completed: 'green',
      cancelled: 'red'
    }
    return colors[status] || 'grey'
  },

  getEnrollmentStatusLabel (status) {
    const labels = {
      enrolled: 'Inscrito',
      completed: 'Completado',
      cancelled: 'Cancelado'
    }
    return labels[status] || 'Desconocido'
  },

  formatDate (dateStr) {
    if (!dateStr) return '--'
    const date = new Date(dateStr)
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  },

  formatDateTime (dateStr) {
    if (!dateStr) return '--'
    const date = new Date(dateStr)
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }
}
